tablinks<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title v-if="isCreate || isInboundCallCreate" id="dr_title">Create Driver</md-dialog-title>
      <md-dialog-title v-if="isUpdate || isInboundCallUpdate" id="dr_title">Update Driver</md-dialog-title>
      <md-dialog-title v-if="isLicExpHist" id="dr_title">License Exp. Date History</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
            <md-button class="md-raised custButton" @click="cancelAction"><span clas="icons-center material-icons"></span>Cancel</md-button>
            <md-button id="create" class="md-raised custButton" @click="saveData"><span class="icons-center material-icons"></span>Save</md-button>
            <md-switch v-model="dataForm.active">Active</md-switch>
         </div> 
         <template v-if="isForFSI">
         <div class="tab">
            <md-button class="tablinks" @click="openTab('Main')" v-if="isCreateUpdate">Main</md-button>
         </div>
        </template>
        <template v-else>
           <div class="tab">
            <md-button class="tablinks" @click="openTab('Main')" v-if="isCreateUpdate">Main</md-button>
            <md-button class="tablinks" @click="openTab('Driver')"  v-if="isCreateUpdate">Driver Info</md-button>
            <md-button class="tablinks" @click="openTab('Area')"  v-if="isCreateUpdate">Area</md-button>
            <md-button class="tablinks" @click="openTab('Billing')"  v-if="isCreateUpdate">Billing</md-button>
            <md-button class="tablinks" @click="openTab('Inbound')"  v-if="isInboundCallCreate">Main</md-button>
          </div>  
        </template>
    <!--       
       <nav>
    <ul>
      <li class="item"><a href="#">link 1</a></li>
      <li class="item"><a href="#">link 2</a></li>
      <li class="item"><a href="#">link 3</a></li>
      <li class="item"><a href="#">link 4</a></li>
      <li class="item"><a href="#">link 5</a></li>
    </ul>
  </nav>
  -->     
      <md-dialog-content >
        <div style="width: 600px; height: 550px">
         <form id="top" @submit.prevent="doSaveUser">
         <md-button type="submit" id="submit" style="display:none;" ></md-button> 
         <span class="info" id="status" style="display:none"></span>
         
         <div id="Main" class="tabcontent" v-if="isMain && !isInboundCallCreate">
            <div v-if="isUpdate" class = "layout">
                <md-field>
                <label for="driverId">DRIVER ID</label>
                <md-input name="driverId" disabled
                        id="driverId"
                        autocomplete="new-password"
                        v-model="dataForm.driverId"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.shortId')">
                <label for="shortId">Driver Name</label>
                <md-input name="shortId"
                        id="shortId"
                        autocomplete="new-password"
                        v-model="dataForm.shortId"
                />
                <span class="md-error" v-if="!$v.dataForm.shortId.required">Driver name is required</span>
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <auto-complete-select :class="getValidationClass('dataForm.userName')"
                                      label="Mobile APP Username"
                                      :options="userIds"
                                      :value="dataForm.userName"
                                      :on-item-changed="handleUserNameChanged"
                ></auto-complete-select>                       
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.driverCompany')"
                                                    group="STC_DRIVER_COMPANY"
                                                    label="DRIVER COMPANY"
                                                    :init-value="dataForm.driverCompany"
                                                    :on-item-changed="handleDriverCompanyChanged">
                                                    name="driverCompany"
                                                    id="driverCompany"
                </auto-complete-master-data-select>
                <span class="md-error" v-if="!$v.dataForm.driverCompany.required">Driver Company is required</span>
            </div>

            <div class = "layout" v-if="isCreate">
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.defaultSalesOffice')"
                                                    group="GST_SALEOFFICE"
                                                    label="SALES OFFICE"
                                                    :init-value="dataForm.defaultSalesOffice"
                                                    :on-item-changed="handleSalesOfficeChanged"
                                                    >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout" v-if="isUpdate">
                <md-field :class="getValidationClass('dataForm.defaultSalesOffice')">
                <label for="defaultSalesOffice">SALES OFFICE</label>
                <md-input name="defaultSalesOffice" disabled
                        id="defaultSalesOffice"
                        autocomplete="new-password"
                        v-model="dataForm.defaultSalesOffice"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.transYard')">
                <label for="defaultPlateNum">Transloading Yard</label>
                <md-input name="transYard"
                        id="transYard"
                        autocomplete="new-password"
                        v-model="dataForm.transYard"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.driverType')"
                                                    group="DRIVER_TYPE"
                                                    label="DRIVER TYPE"
                                                    :init-value="dataForm.driverType"
                                                    :on-item-changed="handleDriverTypeChanged"
                                                    >
                </auto-complete-master-data-select>
                <span class="md-error" v-if="!$v.dataForm.driverType.required">Driver type is required</span>
            </div>

            <div class = "layout" v-if="isUpdate">
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.defaultSalesOffice')"
                                                    group="GST_STATUS"
                                                    label="DRIVER STATUS"
                                                    :init-value="dataForm.driverStatus"
                                                    :on-item-changed="handleDriverStatusChanged"
                                                    >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.trailernum')">
                <label for="trailernum">TRAILER NUM</label>
                <md-input name="trailernum"
                        id="trailernum"
                        autocomplete="new-password"
                        v-model="dataForm.trailernum"
                />
                <!--
                <span class="md-error" v-if="!$v.dataForm.trailernum.required">Trailer number is required</span>
                -->
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.driverMobile')">
                <label for="driverMobile">DRIVER MOBILE</label>
                <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile"
                />
                <span class="md-error" v-if="!$v.dataForm.driverMobile.required">Driver Mobile number is required</span>
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.driverTel')">
                <label for="driverTel">DRIVER TEL</label>
                <md-input name="driverTel"
                        id="driverTel"
                        autocomplete="new-password"
                        v-model="dataForm.driverTel"
                />
                </md-field>
            </div>


         </div>
         <div id="Driver" class="tabcontent" v-if="isDriver">
            <div class = "layout" v-if="isCreateUpdate">
              
                <md-field :class="getValidationClass('dataForm.dmvRecType')">
                <label for="dmvRecType">DMV RECORD TYPE</label>
                <md-input name="dmvRecType"
                        id="dmvRecType"
                        autocomplete="new-password"
                        v-model="dataForm.dmvRecType"
                />
                </md-field>

            </div>

            <div class = "layout" v-if="isCreateUpdate || isInboundCallCreate || isInboundCallUpdate">
                <md-field :class="getValidationClass('dataForm.defaultPlateNum')">
                <label for="defaultPlateNum">Default PLANTE NUM</label>
                <md-input name="defaultPlateNum"
                        id="defaultPlateNum"
                        autocomplete="new-password"
                        v-model="dataForm.defaultPlateNum"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.licenseNum')">
                <label for="licenseNum">LICENSE NUM</label>
                <md-input name="licenseNum"
                        id="licenseNum"
                        autocomplete="new-password"
                        v-model="dataForm.licenseNum"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
              <datepicker v-model="dataForm.licenseExpDate">
                <label>LICENSE EXP DATE</label>
              </datepicker>
            </div>

        </div> 
         <div id="Area" class="tabcontent" v-if="isArea">
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.driverCity')">
                <label for="driverCity">DRIVER CITY</label>
                <md-input name="driverCity"
                        id="driverCity"
                        autocomplete="new-password"
                        v-model="dataForm.driverCity"
                />
                </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
              <auto-complete-master-data-select  :class="getValidationClass('dataForm.driverState')"
                                                    group="State"
                                                    label="DRIVER STATE"
                                                    :init-value="dataForm.driverState"
                                                    :on-item-changed="handleDriverStateChanged"
                                                    >
              </auto-complete-master-data-select>
            </div>

            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.postal')">
                <label for="postal">POSTAL</label>
                <md-input name="postal"
                        id="postal"
                        autocomplete="new-password"
                        v-model="dataForm.postal"
                />
                </md-field>
            </div>
        
        </div> 
        <!-- Driver billing info start -->
        <div id="Billing" class="tabcontent" v-if="isBilling">
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtScaleAddition1')">
                  <label for="scaleAddition">SCALE ADDITION</label>
                  <md-input name="scaleAddition"
                        id="scaleAddition"
                        autocomplete="new-password"
                        v-model="dataForm.amtScaleAddition1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtScaleDeduction1')">
                  <label for="parkingDeduction">SCALE DEDUCTION</label>
                  <md-input name="ScaleDeduction"
                        id="scaleDeduction"
                        autocomplete="new-password"
                        v-model="dataForm.amtScaleDeduction1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtManifestAddition1')">
                  <label for="manifestAddition">MANIFEST ADDITION</label>
                  <md-input name="manifestAddition"
                        id="manifestAddition"
                        autocomplete="new-password"
                        v-model="dataForm.amtManifestAddition1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtManifestDeduction1')">
                  <label for="manifestDeduction">MANIFEST DEDUCTION</label>
                  <md-input name="manifestDeduction"
                        id="manifestDeduction"
                        autocomplete="new-password"
                        v-model="dataForm.amtManifestDeduction1"
                        disabled
                  />
                  </md-field>
            </div>


 
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtParkingAddition1')">
                  <label for="parkingAddition">PARKING ADDITION</label>
                  <md-input name="parkingAddition"
                        id="parkingAddition"
                        autocomplete="new-password"
                        v-model="dataForm.amtParkingAddition1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtParkingDeduction1')">
                  <label for="parkingDeduction">PARKING DEDUCTION</label>
                  <md-input name="parkingDeduction"
                        id="parkingDeduction"
                        autocomplete="new-password"
                        v-model="dataForm.amtParkingDeduction1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtInsuranceAddition1')">
                  <label for="insuranceAddition">INSURANCE ADDITION</label>
                  <md-input name="insuranceAddition"
                        id="insuranceAddition"
                        autocomplete="new-password"
                        v-model="dataForm.amtInsuranceAddition1"
                        disabled
                  />
                  </md-field>
            </div>
            <div class = "layout" v-if="isCreateUpdate">
                <md-field :class="getValidationClass('dataForm.amtInsuranceDeduction1')">
                  <label for="insuranceDeduction">INSURANCE DEDUCTION</label>
                  <md-input name="insuranceDeduction"
                        id="insuranceDeduction"
                        autocomplete="new-password"
                        v-model="dataForm.amtInsuranceDeduction1"
                        disabled
                  />
                  </md-field>
            </div>


        </div>  
        <!-- Driver billing info end -->
        <div id="Inbound" class="tabcontent" v-if="isInbound || isInboundCallCreate || isInboundCallUpdate">
            <div class = "layout" v-if="isCreateUpdate || isInboundCallCreate || isInboundCallUpdate">
                <md-field :class="getValidationClass('dataForm.shortId')">
                <label for="shortId">Name</label>
                <md-input name="shortId"
                        id="shortId"
                        autocomplete="new-password"
                        v-model="dataForm.shortId"
                />
                <span class="md-error" v-if="!$v.dataForm.shortId.required">Driver name is required</span>
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate || isInboundCallCreate || isInboundCallUpdate">
                <md-field :class="getValidationClass('dataForm.driverMobile')">
                <label for="driverMobile">DRIVER MOBILE</label>
                <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile"
                />
                <span class="md-error" v-if="!$v.dataForm.driverMobile.required">Driver Mobile number is required</span>
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate || isInboundCallCreate || isInboundCallUpdate">
                <md-field :class="getValidationClass('dataForm.defaultPlateNum')">
                <label for="defaultPlateNum">Default PLANTE NUM</label>
                <md-input name="defaultPlateNum"
                        id="defaultPlateNum"
                        autocomplete="new-password"
                        v-model="dataForm.defaultPlateNum"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreateUpdate || isInboundCallCreate || isInboundCallUpdate">
                <md-field :class="getValidationClass('dataForm.trailernum')">
                <label for="trailernum">TRAILER NUM</label>
                <md-input name="trailernum"
                        id="trailernum"
                        autocomplete="new-password"
                        v-model="dataForm.trailernum"
                />
                <!--
                <span class="md-error" v-if="!$v.dataForm.trailernum.required">Trailer number is required</span>
                -->
                </md-field>
            </div>


        </div>  
        </form>  
       </div> 
       
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
/*
form {
    min-width: 640px;
    margin: 24px;
  }
*/  

.alwaysShow {
  position: fixed;
  right: 60px;
  top : 30px;
}

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;
}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
  }

  .tab {
      overflow: hidden;
      border: 1px solid #ccc;
      background-color: #f1f1f1;
  }

  .tab button {
      background-color: inherit;
      float: left;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 14px 16px;
      transition: 0.3s;
  }

  .tab button:hover {
      background-color:#ddd;
      text-decoration: underline;
  }

  .tab button:active, button:focus{
      background-color: #ccc;
      text-decoration: underline;
  }

  .tabcontent {
      /*display: none;*/
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-top: none;
      width: 500px;
  }

  .tablinks {
    /*
      font-family: Roboto Slab;
      text-decoration: none;
      font-size: 0.9rem;
    */
      height: 50px;
  }

  .info {
    background-color: #2196f3;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding: 8px;
    height: 30px;
  }

</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    defaultSalesOffice: null,
    driverId: null,
    transYard: null,
    dmvNotifMailOutDate: null,
    dmvRecType: null,
    defaultPlateNum: null,
    driverStatus: null,
    driverType: null,
    drugTestExpDate: null,
    hiringStartDate: null,
    insExpDate: null,
    licenseExpDate: null,
    licenseNum: null,
    medExpDate: null,
    postal: null,
    shortId: null,
    driverCity: null,
    driverMobile: null,
    driverState: null,
    driverTel: null,
    trailernum: null,
    apptNo: null,
    driverOffice: null,
    userName: null,
    driverCompany: null,
    active: true,
    //parking: null,
    //manifestBooklet: null,
    //insurance: null
    amtScaleAddition1: null,
    amtScaleDeduction1: null,
    amtManifestAddition1: null,
    amtManifestDeduction1: null,
    amtParkingAddition1: null,
    amtParkingDeduction1: null,
    amtInsuranceAddition1: null,
    amtInsuranceDeduction1: null
  });

  export default {
    components: { callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      driverOffice: String,
      onCreate: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      items: [],
      selected:null,
      drivers: [],
      isUpdate: false,
      isCreate: true,
      isLicExpHist: false,
      isCreateUpdate: true,
      isInboundCallCreate: false,
      isInboundCallUpdate: false,
      filter: "",
      isMain: true,
      isFSIMain: false,
      isDriver: false,
      isArea: false,
      isBilling: false,
      isInbound: false,
      isForFSI: false,
      users: [],
      userIds: []
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getUsers',
        'getGSTDriverMaster',
        'getGSTDriverTruckLog',
      callingApiCenter,
      ]),
      getGSTDriverTruckLog() {
        console.log("getGSTDriverTrucklog:");
      },  
    filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(null).includes(term)
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

    },

    watch: {
      getGSTDriverMaster(val) {
        this.updateItems(val);
      },
      getGSTDriverTruckLog(val) {
        console.log("watch method");
        this.updateItems(val);
      }
    },


    validations: {
      dataForm: {
          shortId: {required},
          defaultSalesOffice:{},
          driverType:{required},
          transYard:{},
          trailernum: {},
          driverMobile: {required},
          driverCompany: {required}
      },
    },



    methods: {
      async openDialog(requestdata) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        console.log("update form: " + this.mode);
        console.log("request data: " + requestdata);

        this.$store.dispatch('loadUsers', {category: 'A1'});
        this.loadUsers(this.getUsers);

        if (requestdata) {
          console.log("driverOffice: " + this.driverOffice);

          if (this.driverOffice && this.driverOffice != "") {
             this.dataForm.driverOffice = this.driverOffice;
          }
          if (this.mode === "CREATE"){
             this.isCreate = true;
             this.isUpdate = false;
             this.isCreateUpdate = true;
             this.isInboundCallCreate = false;
             this.isInboundCallUpdate = false;
             this.isLicExpHist = false;
             this.isInbound = false;
             this.isMain = true;
             this.isFSIMain = false;
             this.isDriver = false;
             this.isArea = false;
             this.isBilling = false;
             this.dataForm.driverStatus = "Y";
          }
          if (this.mode === 'UPDATE' || this.mode === 'INBOUNDUPDATE'){
             console.log("call in update");
             //this.isUpdate = true;
             this.isCreate = false;
             //this.isCreateUpdate = true;
             this.isLicExpHist = false;
             if (this.mode === 'UPDATE')
             {
                 this.isUpdate = true;
                 this.isCreateUpdate = true;
                 this.isInbound = false;
                 this.isMain = true;
                 this.isFSIMain = false;
                 this.isDriver = false;
                 this.isArea = false;
                 this.isBilling = false;
                 this.isInboundCallUpdate = false;
             }
             else
             {
                 this.isUpdate = false;
                 this.isCreateUpdate = false;
                 this.isInbound = true;
                 this.isMain = false;
                 this.isFSIMain = false;
                 this.isDriver = false;
                 this.isArea = false;
                 this.isBilling = false;
                 this.isInboundCallUpdate = true;
             }
             console.log("dr_title: " + document.getElementById("dr_title"));
             if (document.getElementById("dr_title") != null)
             { 
               console.log("reset create button"); 
               document.getElementById("dr_title").Text = "Update Driver";
             } 
             this.dataForm.driverId = requestdata.driverId;
             this.dataForm.defaultSalesOffice = requestdata.defaultSalesOffice;
             this.dataForm.transYard = requestdata.transYard;
             this.dataForm.dmvNotifMailOutDate = requestdata.dmvNotifMailOutDate;
             this.dataForm.dmvRecType = requestdata.dmvRecType;
             this.dataForm.defaultPlateNum = requestdata.defaultPlateNum;
             this.dataForm.driverStatus = requestdata.driverStatus;
             this.dataForm.driverType = requestdata.driverType;
             this.dataForm.drugTestExpDate = requestdata.drugTestExpDate;
             this.dataForm.hiringStartDate = requestdata.hiringStartDate;
             this.dataForm.insExpDate = requestdata.insExpDate;
             this.dataForm.licenseExpDate = requestdata.licenseExpDate;
             this.dataForm.licenseNum = requestdata.licenseNum;
             this.dataForm.medExpDate = requestdata.medExpDate;
             this.dataForm.postal = requestdata.postal;
             this.dataForm.shortId = requestdata.shortId;
             this.dataForm.driverCity = requestdata.driverCity;
             this.dataForm.driverMobile = requestdata.driverMobile;
             this.dataForm.driverState = requestdata.driverState;
             this.dataForm.driverTel = requestdata.driverTel;
             this.dataForm.trailernum = requestdata.trailernum;
             this.dataForm.userName = requestdata.userName;
             console.log("driverCompany: " + requestdata.driverCompany);
             this.dataForm.driverCompany = requestdata.driverCompany;
             //this.dataForm.parking = requestdata.parking;
             //this.dataForm.manifestBooklet = requestdata.manifestBooklet;
             //this.dataForm.insurance = requestdata.insurance;
             this.dataForm.amtScaleAddition1 = requestdata.amtScaleAddition1;
             this.dataForm.amtScaleDeduction1 = requestdata.amtScaleDeduction1;
             this.dataForm.amtManifestAddition1 = requestdata.amtManifestAddition1;
             this.dataForm.amtManifestDeduction1 = requestdata.amtManifestDeduction1;
             this.dataForm.amtParkingAddition1 = requestdata.amtParkingAddition1;
             this.dataForm.amtParkingDeduction1 = requestdata.amtParkingDeduction1;
             this.dataForm.amtInsuranceAddition1 = requestdata.amtInsuranceAddition1;
             this.dataForm.amtInsuranceDeduction1 = requestdata.amtInsuranceDeduction1;
             this.dataForm.active = requestdata.active;
          }
          if (this.mode === 'LICEXPHIST')
          { 
             console.log("lic exp history list");
             this.isUpdate = false;
             this.isCreate = false;
             this.isCreateUpdate = false;
             this.isLicExpHist = true;
             this.isInbound = false;
             this.isMain = false;
             this.isDriver = false;
             this.isArea = false;
             this.isBilling = false;
             console.log("get Mode: " + this.mode);
             this.updateItems(this.getGSTDriverTruckLog);
          }
        }
          if (this.mode === "INBOUNDCREATE")
          {
             this.isInboundCallCreate = true;
             this.isInboundCallUpdate = false;
             this.isUpdate = false;
             this.isCreate = false;
             this.isCreateUpdate = false;
             this.isLicExpHist = false;
             this.isInbound = true;
             this.isMain = false;
             this.isDriver = false;
             this.isArea = false;
             this.Billing = false;
             this.dataForm.defaultSalesOffice = "LGB";
             this.dataForm.transYard = "1010001";
             this.dataForm.driverStatus = "Y";
             this.dataForm.driverType = "FD";
             this.dataForm.driverCompany = "Dummay(DC9999)";
             this.dataForm.driverOffice = "FSI";
             console.log("requestdata" + requestdata);
             this.dataForm.apptNo = requestdata;
             console.log("dataForm apptNo: " + this.dataForm.apptNo);
          }
        this.showDialog = true;
      },

      updateItems(itemsSource) {
          console.log("itemsSource: " + itemsSource);
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          console.log("items:" + items);
          this.items = items;
      },

      loadUsers(itemsSource) {
         console.log("userlist: " + JSON.stringify(itemsSource));
         this.users = itemsSource;
         this.users.forEach( (it) => {
            if (!this.userIds.includes(it.username))
               this.userIds.push(it.username);
         })
         console.log("userIds: " + JSON.stringify(this.userIds));

      },

      handleScroll(e) {
            $(this.$el.querySelector('.table-header'))
            .offset({
                left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left),
            });
      },


      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      handleSalesOfficeChanged(id){
          console.log('saleoffice id:' + id );
          this.dataForm.defaultSalesOffice = id;
      },

      handleDriverTypeChanged(id){
          console.log('Driver Type id:' + id );
          this.dataForm.driverType = id;
      },

      handleDriverStatusChanged(id){
          console.log('Driver Status id:' + id );
          this.dataForm.driverStatus = id;
      },

      handleDriverStateChanged(id){
          console.log('Driver State id:' + id);
          this.dataForm.driverState = id;
      },

      handleDriverCompanyChanged(id){
          console.log('Driver Company id:' + id);
          this.dataForm.driverCompany = id;
      },

      handleUserNameChanged(id) {
          this.dataForm.userName = id;
      },

      includeNull(field){
                return field==null ? '' : field;
            },



     cancelAction(){
        this.isMain = true;
        this.isDriver = false;
        this.isArea = false;
        this.isBilling = false;
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },

      async doSaveUser() {
        this.isMain = true;
        this.isDriver = false;
        this.isArea = false;
        this.isBilling = false;
        this.$v.dataForm.$touch();
        if (this.$v.dataForm.$invalid) {
          return;
        }
        this.dataForm.driverCompany = this.getContentFromBrace(this.dataForm.driverCompany);
        const req = this.dataForm;

        var statusObj;
        //const result = await api.post("/api/w/gstMasterData/updateDriver", req)
        const result = await newAPIPost("/api/w/gstMasterData/updateDriver", req)
          .then((it) => {
            this.$store.commit('clearApiError');
            console.log("update result: " + it.shortId);
            
            if (it.shortId != "EXISTED")
            {
               this.showDialog = false;
               console.log("apptNo: " + this.dataForm.apptNo);
               this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.trailernum, this.dataForm.apptNo);
               //this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.apptNo);
               $('.btn-search-master-form-driver')
                 .click();
            }
            else
            {
               statusObj = document.getElementById("status");
               console.log("statusObj: " + statusObj);
               if (statusObj)
               {
                  statusObj.innerText = "Update Status: FAILED (Info may be existed)";
                  statusObj.style.display = "";
               }

            }
            
          });
      },

      //openTab(evt, tabname) {
      openTab(tabname)  {
         /*
         var i, tabcontent, tablinks;

         // Get all elements with class="tabcontent" and hide them
         tabcontent = document.getElementsByClassName("tabcontent");
         for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
         }

         // Get all elements with class="tablinks" and remove the class "active"
         tablinks = document.getElementsByClassName("tablinks");
         for (i = 0; i < tablinks.length; i++) {
             tablinks[i].className = tablinks[i].className.replace(" active", "");
         }

         // Show the current tab, and add an "active" class to the button that opened the tab
         document.getElementById(tabname).style.display = "block";
         evt.currentTarget.className += " active";   
        */
         console.log("tabname: " + tabname);
         
         if (tabname === "Main")
         {
            this.isMain = true;
            this.isDriver = false;
            this.isArea = false;
            this.isBilling = false;
         }

         if (tabname === "Driver")
         {
            this.isMain = false;
            this.isDriver = true;
            this.isArea = false;
            this.isBilling = false;
         }

         if (tabname === "Area")
         {
            this.isMain = false;
            this.isDriver = false;
            this.isArea = true;
            this.isBilling = false;
         }

         if (tabname === "Billing")
         {
            this.isMain = false;
            this.isDriver = false;
            this.isArea = false;
            this.isBilling = true;
         }

      },

      getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
      },

      saveData() {
         //this.doSaveUser();
         $("#submit").click();
      },
    },
  };
</script>